"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalBudgetTemplatesData = void 0;
exports.globalBudgetTemplatesData = {};
// budgetTemplatesRef.onSnapshot((data) => {
//   Object.defineProperty(globalBudgetTemplatesData, "loaded", {
//     enumerable: false,
//     value: true,
//   });
//   data.docs.forEach((doc) => {
//     globalBudgetTemplatesData[doc.id] = {
//       ...doc.data(),
//       id: doc.id,
//     } as BudgetTemplateWithId;
//   });
// });
